import React, { useState, ChangeEvent } from 'react';
import { useStyles } from '../../style';
import { Box, Grid, TextField, Typography, FormControl, MenuItem, InputAdornment, IconButton, Checkbox, FormControlLabel } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import KenButton from '../../../../GlobalComponents/KenButton';
import { postEmployeementDetails } from '../../../../Utils/apiService';
import { EmployeementDetails } from '../../../../interfaces/Profile';
import dayjs, { Dayjs } from 'dayjs';
import { enqueueSnackbar } from 'notistack';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid white',
  boxShadow: 24,
  borderRadius: 2,
  width: { lg: '40vw', xl: '40vw' },
  p: 2,
  height: { lg: '75vh', xl: '75vh' },
};

const AddEmployeeDetails = (props: any) => {
  console.log('props', props);
  const { userData, value } = props;
  console.log('userData12', value);

  const classes = useStyles();
  const [employementType, setEmployementType] = React.useState(value?.Employment_Type__c ? value?.Employment_Type__c : '');
  const [locationType, setLocationType] = React.useState('');
  const [location, setLocation] = React.useState(value?.Location__c ? value?.Location__c : '');
  const [formData, setFormData] = useState<EmployeementDetails>({
    title: value?.Title__c ? value?.Title__c : '',
    companyName: value?.Company__r?.Name ? value?.Company__r?.Name : '',
    employmentType: value?.Employment_Type__c ? value?.Employment_Type__c : '',
    location: value?.Location__c ? value?.Location__c : '',
    startDate: value?.Start_Date__c ? value?.Start_Date__c : '',
    endDate: value?.End_Date__c ? value?.End_Date__c : '',
    contactId: userData.applicantId,
    fileBlob: value?.Company__r?.Logo_File_URL__c ? value?.Company__r?.Logo_File_URL__c : '',
    fileName: value?.Title__c ? value?.Title__c : '',
    currentlyworkinghere: false,
  });
  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs(value?.Start_Date__c ? value?.Start_Date__c : dayjs()));
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs(value?.End_Date__c ? value?.End_Date__c : dayjs()));
  const [fileName, setFileName] = useState<string>('');
  const [base64Image, setBase64Image] = useState<string | null>(value?.Company__r?.Logo_File_URL__c ? value?.Company__r?.Logo_File_URL__c : null);

  const handleChangeStartDate = (newDate: Dayjs | null) => {
    setStartDate(newDate);
  };

  const handleChangeEndDate = (newDate: Dayjs | null) => {
    setEndDate(newDate);
  };
  const handleChange = (event: SelectChangeEvent) => {
    setEmployementType(event.target.value as string);
  };
  const handleChangeLocation = (event: SelectChangeEvent) => {
    setLocation(event.target.value as string);
  };
  const handleChangeLocationType = (event: SelectChangeEvent) => {
    setLocationType(event.target.value as string);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        const splitData = base64String.split(',');
        setBase64Image(splitData[1]);
        console.log('Base64 Image: ', base64String);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleChangeField = (event: ChangeEvent<HTMLInputElement>): void => {
    const { name, type, value, checked } = event.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const postEmployeementsDetails = () => {
    const payload: any = {
      ...formData,
      employmentType: employementType,
      location,
      startDate,
      endDate,
      fileBlob: base64Image,
      fileName: fileName,
    };
    console.log('payload324', payload);

    postEmployeementDetails(payload)
      .then((res) => {
        if (res?.success) {
          props.setPreferStatus(true);
          enqueueSnackbar({
            message: 'Employeement Details Saved Sucessfully',
            variant: 'success',
            autoHideDuration: 1000,
          });
          props.handleClose();
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        props.handleClose();
        console.error(err);
      });
  };

  return (
    <div>
      <Box sx={style}>
        <Typography sx={{ textAlign: 'left', fontWeight: 500, fontSize: '13px' }}>{props.data == 'edit' ? 'Edit Position' : 'Add Position'}</Typography>
        <hr style={{ border: '1px solid #E6E6E8' }} />
        <Grid
          container
          spacing={2}
          sx={{
            marginTop: '-40px',
            height: '58vh',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              height: '54vh',
            },
          }}
          className="scrollbar-cusgray"
        >
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>Title</Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              name="title"
              value={formData.title}
              onChange={handleChangeField}
              placeholder="Enter title"
              variant="outlined"
              fullWidth
            />
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>Employment Type</Typography>
            <FormControl fullWidth sx={{ mt: 1.5 }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={employementType}
                placeholder="Select"
                onChange={handleChange}
                size="small"
                sx={{
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3061FF',
                  },
                  height: '36px',
                  fontSize: '12px',
                  '& .MuiOutlinedInput-root': {
                    height: '36px',
                    fontSize: '12px',
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: '12px',
                  },
                }}
              >
                <MenuItem
                  value={'Full time'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Full time
                </MenuItem>
                <MenuItem
                  value={'Part Time'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Part Time
                </MenuItem>
                <MenuItem
                  value={'Intern'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Intern
                </MenuItem>
              </Select>
            </FormControl>
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>Location Type</Typography>
            <FormControl fullWidth sx={{ mt: 1.5 }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={locationType}
                placeholder="Select"
                onChange={handleChangeLocationType}
                size="small"
                sx={{
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3061FF',
                  },
                  height: '36px',
                  fontSize: '12px',
                  '& .MuiOutlinedInput-root': {
                    height: '36px',
                    fontSize: '12px',
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: '12px',
                  },
                }}
              >
                <MenuItem
                  value={'Onsite'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Onsite
                </MenuItem>
                <MenuItem
                  value={'Hybrid'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Hybrid
                </MenuItem>
                <MenuItem
                  value={'Remote'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Remote
                </MenuItem>
              </Select>
            </FormControl>
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>Start Date</Typography>
            <Box sx={{ mt: 1.5 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  value={startDate}
                  onChange={handleChangeStartDate}
                  slots={{
                    textField: (params) => (
                      <TextField
                        {...params}
                        size="small"
                        fullWidth
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            height: '36px',
                            borderRadius: '6px',
                            fontSize: '12px',
                          },
                          '& .MuiOutlinedInput-input': {
                            fontSize: '12px',
                          },
                        }}
                      />
                    ),
                  }}
                />
              </LocalizationProvider>
            </Box>
            <Typography sx={{ mt: 4, ml: 0 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="currentlyworkinghere"
                    sx={{
                      '& .MuiSvgIcon-root': {
                        fontSize: '18px',
                      },
                    }}
                    checked={formData.currentlyworkinghere}
                    onChange={handleChangeField}
                  />
                }
                label={<Typography sx={{ fontSize: '12px' }}>I'm Currently Working Here</Typography>}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>Add Company Logo</Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              variant="outlined"
              fullWidth
              size="small"
              placeholder="Upload Image"
              value={fileName}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton component="label">
                      <input type="file" hidden accept="image/*" onChange={handleFileChange} />
                      <FileUploadOutlinedIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>Company Name</Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              placeholder="Enter Company Name"
              name="companyName"
              value={formData.companyName}
              onChange={handleChangeField}
              variant="outlined"
              fullWidth
            />
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>Location</Typography>
            <FormControl fullWidth sx={{ mt: 1.5 }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={location}
                placeholder="Select"
                onChange={handleChangeLocation}
                size="small"
                sx={{
                  height: '36px',
                  fontSize: '12px',
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3061FF',
                  },
                  '& .MuiOutlinedInput-root': {
                    height: '36px',
                    fontSize: '12px',
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: '12px',
                  },
                }}
              >
                <MenuItem
                  value={'Coimbatore'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Coimbatore
                </MenuItem>
                <MenuItem
                  value={'Chennai'}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&:active': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Chennai
                </MenuItem>
              </Select>
            </FormControl>
            <Typography sx={{ fontWeight: 500, mt: 4, fontSize: '12px' }}>End Date</Typography>
            <Box sx={{ mt: 1.5 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  value={endDate}
                  onChange={handleChangeEndDate}
                  slots={{
                    textField: (params) => (
                      <TextField
                        {...params}
                        size="small"
                        fullWidth
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            height: '36px',
                            borderRadius: '6px',
                            fontSize: '12px',
                          },
                          '& .MuiOutlinedInput-input': {
                            fontSize: '12px',
                          },
                        }}
                      />
                    ),
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
          <KenButton
            variant="text"
            className={classes.button}
            sx={{
              mt: 1,
              borderRadius: '8px',
              width: 100,
              '&:hover': {
                backgroundColor: 'transparent',
              },
              color: 'black',
            }}
            onClick={props.handleClose}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: '500', color: '#373A45' }}>Cancel</Typography>
          </KenButton>
          <KenButton
            variant="contained"
            className={classes.button}
            style={{ marginTop: 15, borderRadius: '8px', width: 100, marginLeft: 10, boxShadow: 'none', height: '36px' }}
            onClick={() => {
              postEmployeementsDetails();
            }}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>Save</Typography>
          </KenButton>
        </Box>
      </Box>
    </div>
  );
};

export default AddEmployeeDetails;
